/*
 * File: /src/store/modules/contentBlocks.js
 * Created Date: Tuesday December 14th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 14th December 2021 3:46:13 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import ContentBlockService from 'src/services/contentBlockService';

const state = {
  contentBlocks: undefined,
};

// Keep a block when there is no active global brand filter, when the block has
// no brands (unbranded blocks are always available), or when the block's brands
// intersect the globally selected brands. Mirrors the tag/brand filter used on
// reservations (ReservationList `filteredTags`).
const matchesBrandFilter = (block, brandIds) => {
  if (!brandIds) {
    // undefined/null means "no filter" - show everything
    return true;
  }
  if (!block.brand_ids || block.brand_ids.length === 0) {
    // Unbranded blocks are available under any brand selection
    return true;
  }
  return block.brand_ids.some((id) => brandIds.includes(id));
};

const getters = {
  getBlocks: (state) => state.contentBlocks,
  getBlockById: (state) => (id) =>
    state.contentBlocks?.find((c) => c.id == id),
  getTextBlocks: (state, getters, rootState, rootGetters) => {
    const brandIds = rootGetters['auth/getGlobalBrandIds'];
    return (state.contentBlocks || []).filter(
      (c) => c.block_type == 'text' && matchesBrandFilter(c, brandIds)
    );
  },
  getHtmlBlocks: (state, getters, rootState, rootGetters) => {
    const brandIds = rootGetters['auth/getGlobalBrandIds'];
    return (state.contentBlocks || []).filter(
      (c) => c.block_type == 'html' && matchesBrandFilter(c, brandIds)
    );
  },
};
const actions = {
  async fetchBlocks({ commit, state }) {
    // Only load the data once
    if (state.contentBlocks == undefined) {
      // Only load active blocks into the store
      return ContentBlockService.fetchAll({ filter: ['active:eq:true'] }).then(
        (r) => {
          commit('setBlocks', r.data);
        }
      );
    }
  },
  unloadBlocks({ commit }) {
    commit('setBlocks', undefined);
  },
};
const mutations = {
  setBlocks(state, blocks) {
    state.contentBlocks = blocks;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
